define([
	"dojo/_base/declare",
	"underscore",
	"./PartMaterials"
], function(declare,_,PartMaterials) {

	return declare(PartMaterials, {
		// Boolean: override to use expandLevel rather than displayCommentLines
		bSupportsExpandLevelOption: true,

		// Boolean: indicate that widget provides DependencyPath necessary to quickly expand to child BOM items
		bSupportsNonBranchingPathsForExpansion: true,

		_redrawNode: function(/*DOMNode*/element) {
			// summary: any time attribute changes, we need to refresh child PartMaterial rows to update matrix
			var row = this.getRefNode(element);
			if (row) {
				_.each(this.getRowChildren(row, true, true), function(childRow) {
					this._refreshRow(childRow);
				}, this);
			}

			this.inherited(arguments);
		}
	});
});
